import { isWeb } from "./runtimeEnvironment"

export function getDocument() {
  return isWeb() ? document : null
}

export function getBody() {
  return isWeb() ? document.body : null
}
